import React, { useCallback, useContext, useMemo } from 'react';
import { Button, FlexMiddle, PromptClick, StickyBar } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import styled from 'styled-components';
import privileges from '@ubeya/shared-web/privileges';

const Selection = styled.span`
  align-items: center;
  font-size: 16px;
  font-weight: 500;
`;

const Buttons = styled(FlexMiddle)`
  > button {
    margin-left: 10px;
  }
`;

const getButtonType = (buttonType) => {
  return {
    primary: buttonType === 'primary',
    secondary: buttonType === 'secondary'
  };
};

const RequestModalStickyBar = ({
  checkedRequests,
  totalRequests,
  onClose,
  setIsDeclineModalOpen,
  handleApproveAllRequests
}) => {
  const { t } = useContext(ConfigContext);

  const handleApproveAllConfirm = useCallback(async () => {
    await handleApproveAllRequests();
    onClose();
  }, [handleApproveAllRequests, onClose]);

  const actions = useMemo(
    () => [
      {
        confirmText: 'declineAll',
        label: t('declineAll'),
        actionRequiredPrivilege: [privileges.DELETE_EMPLOYEE],
        onClick: () => setIsDeclineModalOpen({ requestIds: checkedRequests.map(({ id }) => id), isBulk: true }),
        buttonType: 'secondary',
        isPromptEnabled: false
      },
      {
        title: t('areYouSureApproveRequests'),
        label: t('approveAll'),
        body:
          checkedRequests.length === 1
            ? t('areYouSureApproveXRequest', { amount: checkedRequests.length })
            : t('areYouSureApproveXRequests', { amount: checkedRequests.length }),
        confirmText: t('approve'),
        actionRequiredPrivilege: [privileges.EDIT_PERMISSIONS],
        onClick: handleApproveAllConfirm
      }
    ],
    [handleApproveAllConfirm, t, setIsDeclineModalOpen, checkedRequests]
  );

  return (
    <StickyBar
      leftSide={
        <>
          <Button tertiary narrow onClick={onClose}>
            {t('cancel')}
          </Button>

          <Selection>{t('amountOutOfTotal', { total: totalRequests, amount: checkedRequests.length })}</Selection>
        </>
      }
      rightSide={
        <Buttons>
          {(actions || []).map(
            (
              {
                onCloseModal,
                onClick,
                title,
                renderBody,
                body,
                label,
                confirmText,
                isDisabled,
                buttonType = 'primary',
                isPromptEnabled = true
              },
              index
            ) => (
              <PromptClick
                key={index}
                onClick={onClick}
                usePortal
                title={title}
                body={body}
                onClose={onCloseModal}
                renderBody={renderBody}
                confirmText={confirmText}
                enable={isPromptEnabled}>
                <Button {...getButtonType(buttonType)} narrow disabled={checkedRequests.length === 0 || isDisabled}>
                  {label}
                </Button>
              </PromptClick>
            )
          )}
        </Buttons>
      }
    />
  );
};

export default RequestModalStickyBar;
